import { call, put } from 'redux-saga/effects';
import { commentService } from '../services/commentService.ts';
import { commentConstants } from '../actions/constants/commentConstants';


function* getCommentsList(action: any): any {
  try {
    const response = yield call(commentService.getCommentsList, action.payload);
    if (response && response.success) {
      yield put({ type: commentConstants.getCommentsListSuccess, payload: response.resultObject.availability });
    } else {
      yield put({ type: commentConstants.getCommentsListFailure, payload: response?.message || response });
    }
  } catch (error: any) {
    yield put({ type: commentConstants.getCommentsListFailure, payload: error });
  }
}

function* addComment(action: any): any {
  const { onSuccess, ...params } = action.payload;
  try {
    const response = yield call(commentService.addComment, params);
    if (response && response.success) {
      yield put({ type: commentConstants.addCommentSuccess, payload: response.resultObject });
      if (onSuccess) onSuccess();
    } else {
      yield put({ type: commentConstants.addCommentFailure, payload: response?.message || response });
    }
  } catch (error: any) {
    yield put({ type: commentConstants.addCommentFailure, payload: error });
  }
}

function* editComment(action: any): any {
  const { commentId, onSuccess, ...params } = action.payload;
  try {
    const response = yield call(commentService.editComment, commentId, params);
    if (response && response.success) {
      yield put({ type: commentConstants.editCommentSuccess, payload: response.resultObject });
      if (onSuccess) onSuccess();
    } else {
      yield put({ type: commentConstants.editCommentFailure, payload: response?.message || response });
    }
  } catch (error: any) {
    yield put({ type: commentConstants.editCommentFailure, payload: error });
  }
}

export const commentSaga = {
    getCommentsList,
    addComment,
    editComment,
}